<!--
 * @Author: xiongang
 * @Date: 2021-07-01 10:56:03
 * @LastEditTime: 2021-07-13 16:27:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xingmahui_front\src\views\contents\foodColumn\component\foodmenu.vue
-->


<script>
export default {
  props: {
    foodHtml: {
      type: String,
    },
    isLine:{
      type: Boolean,
      default:true
    }
  },
  render() {
    return (
      <div>
        <div class="food-information">
          <div domPropsInnerHTML={this.foodHtml}></div>
        </div>
        {this.isLine&&this.foodHtml&&<p class="line"></p >}
      </div>
    );
  },
};
</script>
<style lang="less" scoped>
.food-information {
  padding: 0 12px ;
}
.line {
  height: 10px;
  background: #f2f2f2;
}
</style>
